/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { NavLink } from "react-router-dom";

import Translate from "../../i18n/Translate";
import { useTranslation } from "react-i18next";

import { SocialMedia } from "../../components/icons";
import SubscribeForm from "../Footer/components/SubscribeForm";
import DataFiscalISOSection from "../Footer/components/DataFiscalISOSection";

//svg
import Logo from "../../assets/images/static/Logo_white.svg";
import Phone from "../../assets/images/icons/Footer_phone.svg";
import Mail from "../../assets/images/icons/Footer_mail.svg";
import Location from "../../assets/images/icons/Footer_location.svg";

//SCSS VARIABLES
import configVariables from "../../assets/scss/variables/colors.module.scss";

const Footer = ({ language }) => {
  //Substraer todos los caracteres luego de los dos primeros en caso de que el language sea mayor a 2 EJ: es-ES
  const { t } = useTranslation();
  const { colorClaro, colorPrimario } = configVariables;

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__container__column1">
          <img
            src={Logo}
            alt="Tower Partners Logo"
            title="Tower Partners Logo"
          />

          <p>
            <Translate langkey="footer.column1.copy" />
          </p>

          <div className="footer__container__column1__info">
            <a href="https://goo.gl/maps/FeeGLFaTHoDLdZtP8" target="_blank" rel="noreferrer">
              <img src={Location} alt="Location" />
              <span>
                <Translate langkey="footer.column1.address" />
              </span>
            </a>

            <a href="tel:+541152177400" target="_blank" rel="noreferrer">
              <img src={Phone} alt="Phone" />
              <Translate langkey="footer.column1.phone" />
            </a>

            <a
              href="mailto:info@towertravel.com.ar"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Mail} alt="Mail" />
              <Translate langkey="footer.column1.email" />
            </a>
          </div>

          <div className="footer__container__column1__social">
            <SocialMedia
              fill={colorClaro}
              background={colorPrimario}
              fb
              ig
              lin
              tt
              yt
            />
          </div>
        </div>

        <div className="footer__container__column2">
          <h3>
            <Translate langkey="footer.column2.title" />
          </h3>

          <ul>
            {/* Home */}
            <li>
            <NavLink to={`${t("routes.home")}`} exact>
                <Translate langkey={`${t("routes.home-text")}`} />
              </NavLink>
            </li>

            {/* Institucional */}
            <li>
              <NavLink to={`${t("routes.institutional")}`}>
                <Translate langkey="routes.institutional-text" />
              </NavLink>
            </li>

            {/* Paquetes deportivos */}
            <li>
              <NavLink to={`${t("routes.psports")}`}>
                <Translate langkey={`${t("routes.psports-text")}`} />
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="footer__container__column3">
          <h3>
            <Translate langkey="footer.column3.title" />
          </h3>

          <ul>
            <li>
              <NavLink to={`${t("routes.contact")}`}>
                <Translate langkey="footer.column3.links.link1" />
              </NavLink>
            </li>

            {/* <li>
              <NavLink to={`/${language}${t("routes.faqs")}`}>
                <Translate langkey="footer.column3.links.link2" />
              </NavLink>
            </li> */}
          </ul>
        </div>

        <div className="footer__container__column4">
          <h3>
            <Translate langkey="footer.column4.title" />
          </h3>

          <p>
            <Translate langkey="footer.column4.copy" />
          </p>

          <div className="footer__container__column4-input">
            <SubscribeForm language={language} />
          </div>
        </div>

        <div className="footer__container__column5">
          <DataFiscalISOSection language={language} />
        </div>

        <div className="footer__container__footer">
          <div className="copys">
            <p>
              <Translate langkey="footer.footer.copy1" />
            </p>
            <p>
              <Translate langkey="footer.footer.copy2" />{" "}
              <a
                href="https://bigsurbranding.com/"
                target="_blank"
                rel="noreferrer"
              >
                <span>Big Sur Branding</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
